console.log('📦 Parcel is up and running!');
